const getCycleKey = cycle => {
  var _cycle$interval, _cycle$interval2;
  if (cycle.oneTime) {
    return 'ONE_TIME';
  }
  if (!((_cycle$interval = cycle.interval) != null && _cycle$interval.unit) || !((_cycle$interval2 = cycle.interval) != null && _cycle$interval2.count)) {
    return 'INVALID';
  }
  return `${cycle.interval.unit}_${cycle.interval.count}`;
};
const getOfferingPurchasableCycles = products => {
  if (!products) {
    return [];
  }
  const uniqueCyclesMap = products.reduce((acc, product) => {
    var _product$purchasableC;
    (_product$purchasableC = product.purchasableCycles) == null || _product$purchasableC.forEach(cycle => {
      const key = getCycleKey(cycle);
      if (!acc.has(key)) {
        acc.set(key, cycle);
      }
    });
    return acc;
  }, new Map());
  return Array.from(uniqueCyclesMap.values());
};
export { getOfferingPurchasableCycles };
//# sourceMappingURL=cycleUtils.js.map